<template>
  <div>
    <span class="total">검색결과 <span class="num">{{ totalKeywordCnt }}</span>건</span>
    <ul class="search-result-list">
      <li v-for="(data, idx) in statisticsKeywordData" v-bind:key="idx">
        <a href="#/" @click="showStatisticsPopup(data.upPath, data.levelId2, data.tblMgmNo)">
          <div class="title-address">
            <strong class="result-title">{{ data.tblKorNm }}</strong>
            <div class="address">
              <span>{{ data.upPath }}</span>
            </div>
          </div>
        </a>
      </li>
    </ul>

    <div class="btn-layout center" v-if="isSearchData">
      <button type="button" class="line btn" @click="statisticsKeywordList">더보기</button>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/Statistics";

export default {
  name: "SubjectSearchResultView",

  props: {
    statId: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      searchText: '',
      isSearchData: true,
      totalKeywordCnt: 0,
      boardPageIndex: 0,
      boardStartPage: 0,
      boardEndPage: 0,
      statisticsKeywordData: [], // 키워드검색 데이터
      boardCount: 10,
    }
  },

  methods: {

    /**
     * 초기화
     */
    initialize() {
      this.searchText = '';
      this.totalKeywordCnt = 0
    },

    /**
     * search
     * 검색버튼 클릭 시 (키워드 검색)
     */
    search (text) {
      this.searchText = text;
      this.boardPageIndex = 0
      this.boardStartPage = 0
      this.boardEndPage = 0
      this.statisticsKeywordData = []
      this.isSearchData = true
      this.statisticsKeywordList();
    },

    // 키워드 검색
    async statisticsKeywordList () {
      this.boardPageIndex = this.boardPageIndex + 1
      this.boardStartPage = ((this.boardPageIndex - 1) * this.boardCount) + 1
      this.boardEndPage = this.boardPageIndex * this.boardCount

      const paramData = {
        searchText: this.searchText,
        levelId2: this.statId,
        startPage: this.boardStartPage,
        endPage: this.boardEndPage
      }

      const staticData = await api.statisticsKeywordList(paramData);

      if (staticData.data.length > 0) {
        staticData.data.forEach(data => this.statisticsKeywordData.push(data));
      }

      if (staticData.data.length < this.boardCount) {
        this.isSearchData = false;
      }

      this.totalKeywordCnt = staticData.cnt;
    },

    /**
     * 통계표 새창 띄우기
     *
     * @param upPath
     * @param levelId2
     * @param tblMgmNo
     */
    showStatisticsPopup(upPath, levelId2, tblMgmNo) {
      this.$emit('show-statistics-popup',upPath, levelId2, tblMgmNo);
    },
  },


}
</script>

<style scoped>

</style>
